import * as React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import QuillEditor from 'src/components/Shared/QuillEditor';
import InputErrorClass from 'src/components/Shared/InputErrorClass';
import { LANGUAGES } from 'src/globals';

export default class Text extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { values, setFieldValue, errors, handleChange } = this.props;

    return (
      <div>
        <div className="form-group">
          <label>Subtipo</label>
          <select
            className={InputErrorClass({ errors, name: 'data.text.type' })}
            name="data.text.type"
            onChange={handleChange}
            value={values.data.text.type}
          >
            <option value=""></option>
            <option value="1">Opcion 1</option>
            <option value="2">Opcion 2</option>
            <option value="3">Opcion 3</option>
          </select>
          {errors['data.text.type'] && <p className="invalid-feedback">{errors['data.text.type']}</p>}
        </div>
        <Tabs className="nav-fill" style={{ cursor: 'pointer' }}>
          <TabList>
            {
              Object.keys(LANGUAGES).map((key: string, i: number) => (
                <Tab key={i}>{LANGUAGES[key]}</Tab>
              ))
            }
          </TabList>
          {
            Object.keys(LANGUAGES).map((key: string, i: number) => (
              <TabPanel key={i}>
                <QuillEditor
                  label={`Descripcion corta (${key})`}
                  value={values.data.text[key].shortDescription}
                  onChange={(value: any) => {
                    setFieldValue(`data.text.${key}.shortDescription`, value);
                  }}
                />
                <QuillEditor
                  label={`Texto (${key})`}
                  value={values.data.text[key].text}
                  onChange={(value: any) => {
                    setFieldValue(`data.text.${key}.text`, value);
                  }}
                />
              </TabPanel>
            ))
          }
        </Tabs>
        <hr/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Text.tsx